'use client';

import Link from 'next/link';
import { getLocalStorage, setLocalStorage } from '../lib/storageHelper';
import { useState, useEffect } from 'react';
import { waitForGtag } from "../lib/gtagHelper";


export default function CookieBanner() {

    const [cookieConsent, setCookieConsent] = useState(false);

    useEffect (() => {
        const storedCookieConsent = getLocalStorage("cookie_consent", null);

        setCookieConsent(storedCookieConsent);
    }, [setCookieConsent]);

    useEffect(() => {
        const newValue = cookieConsent ? 'granted' : 'denied'

        waitForGtag(() => { 
            window.gtag("consent", 'update', { 
                'analytics_storage': newValue,
                'ad_storage': 'denied', 
            }); 
        });
        
        /*
        window.gtag("consent", 'update', {
            'analytics_storage': newValue
        });
        */

        setLocalStorage("cookie_consent", cookieConsent)

        //For Testing
        console.log("Cookie Consent: ", cookieConsent)

    }, [cookieConsent]);

    return (
        <div className={`my-10 mx-auto max-w-max md:max-w-screen-sm
                        fixed bottom-0 left-0 right-0 
                        ${cookieConsent != null ? "hidden" : "flex"} px-3 md:px-4 py-3 justify-between items-center flex-col sm:flex-row gap-4  
                         bg-bluebirdgreen bg-opacity-80 rounded-lg shadow`}>

            <div className='text-center'>
                <Link href="./privacypolicy"><p className='text-white'>We use <span className=''>cookies</span> on our site.</p></Link>
            </div>

            
            <div className='flex gap-2'>
                <button className='px-5 py-2 text-white font-bold rounded-md border-gray-900' onClick={() => setCookieConsent(false)}>Decline</button>
                <button className='bg-opacity-100 bg-bluebirdblue px-5 py-2 text-white font-bold rounded-lg' onClick={() => setCookieConsent(true)}>Allow Cookies</button>
            </div>   
        </div>
    )
}